import { APP_STORE_URL, PLAY_STORE_URL } from "@groupeo/shared";
import { useTranslation } from "react-i18next";
import { RevealOnView } from "../reveal-on-view";
import { StoreButton } from "../store-button";

interface CtaSectionProps {
	title?: string;
	body?: string;
}

export function CtaSection({ title, body }: CtaSectionProps) {
	const { t } = useTranslation("marketing");
	const effectiveTitle = title ?? t("cta_title");
	const effectiveBody = body ?? t("cta_body");

	return (
		<section
			id="cta"
			className="mt-16 scroll-mt-28 rounded-[2.6rem] border border-white/10 bg-[linear-gradient(135deg,rgba(255,255,255,0.08),rgba(255,90,95,0.08),rgba(255,255,255,0.06))] px-8 py-12 shadow-[0_40px_100px_-58px_rgba(0,0,0,0.76)] backdrop-blur sm:px-12"
		>
			<RevealOnView from="up">
				<div className="flex flex-col gap-8 lg:flex-row lg:items-center lg:justify-between">
					<div className="max-w-2xl">
						<p className="text-4xl font-semibold tracking-[-0.06em] text-white sm:text-5xl">{effectiveTitle}</p>
						<p className="mt-5 text-lg leading-8 text-white/70">{effectiveBody}</p>
					</div>
					<div className="flex flex-col gap-4 sm:flex-row">
						<StoreButton href={APP_STORE_URL} label={t("cta_primary")} variant="primary" />
						<StoreButton href={PLAY_STORE_URL} label={t("cta_secondary")} variant="secondary" />
					</div>
				</div>
			</RevealOnView>
		</section>
	);
}
